import ImmunizationTdapView from "./ImmunizationTdapView";

export default ImmunizationTdapView;
